import type { TI18nKey } from '@muse/i18n'

export const INSIGHTS_PROMO_COPY = {
    titleKey: 'i18n.insightsPromoTitle',
    descriptionKey: 'i18n.insightsPromoDescription',
    ctaKey: 'i18n.commonTryNow',
    imageAltKey: 'i18n.insightsPromoImageAlt',
} satisfies Record<
    string,
    TI18nKey<
        | 'i18n.insightsPromoTitle'
        | 'i18n.insightsPromoDescription'
        | 'i18n.commonTryNow'
        | 'i18n.insightsPromoImageAlt'
    >
>
